import { c as _c } from "react/compiler-runtime";
import { cn } from '@/frontend/utils';
type CoolifyProps = React.SVGProps<SVGSVGElement> & {
  size?: string | number;
};
export function Coolify(t0) {
  const $ = _c(13);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  const sizeClass = size ? `size-${size}` : "size-12";
  let t1;
  if ($[4] !== className || $[5] !== sizeClass) {
    t1 = cn(sizeClass, className);
    $[4] = className;
    $[5] = sizeClass;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M63.7-161.7h-90.9v272.8h90.9zm0 363.7h363.7v-90.9H63.7zm0-363.7h363.7v-90.9H63.7z" style={{
      fill: "#8c52ff",
      fillOpacity: 0.302
    }} transform="translate(84.664 310.016)" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M48.2-177.1h-90.9V95.6h90.9zm0 363.6h363.7V95.6H48.2zm0-363.6h363.7V-268H48.2z" style={{
      fill: "#8c52ff",
      fillOpacity: 0.502
    }} transform="translate(71.406 296.758)" />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M32.8-192.6h-90.9V80.2h90.9zm0 363.7h363.7V80.2H32.8zm0-363.7h363.7v-90.9H32.8z" style={{
      fill: "#8c52ff"
    }} transform="translate(58.147 283.5)" />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props || $[11] !== t1) {
    t5 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 512 512" className={t1} {...props}>{t2}{t3}{t4}</svg>;
    $[10] = props;
    $[11] = t1;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}